import React from 'react';
import { observer, inject } from 'mobx-react';
import { Table, Button, Input } from 'antd';
import { AddGroupTable } from '../../const/TableConst';
import styles from './DeviceSearchForm.less';

@inject('addGroupStore')
@observer
class DeviceSelectedTable extends React.Component {
  onSelectChange = (selectedDeviceArr, selectedRows) => {
    this.props.addGroupStore.selectedDeviceArr = selectedRows;
  };
  render() {
    const {
      searchDeviceArr,
      selectedDeviceArr,
      selectedDevicePageSize,
      changeSelectedPageSize
    } = this.props.addGroupStore;
    const hasSelected = selectedDeviceArr.length > 0;
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
          <span style={{ marginLeft: 8 }}>
            {hasSelected ? `选择了${selectedDeviceArr.length} 台设备` : ''}
          </span>
        </div>
        <Table
          pagination={{
            showTotal: total => (
              <div className={styles.pageSizeContainer}>
                <span>每页显示条数</span>
                <Input
                  className={styles.numInput}
                  defaultValue={10}
                  type="text"
                  onChange={e => changeSelectedPageSize(e)}
                />
              </div>
            ),
            pageSize: selectedDevicePageSize
          }}
          columns={AddGroupTable}
          dataSource={[...selectedDeviceArr]}
        />
      </div>
    );
  }
}
export default DeviceSelectedTable;



// WEBPACK FOOTER //
// ./src/components/DeviceGroup/DeviceSelectedTable.js